
/**
 * @export
 * @enum {string}
 */
export enum UserEventSource {
    ALERT = 'ALERT',
    APPCUES = 'APPCUES',
    CHROME_PLUGIN = 'CHROME_PLUGIN',
    CRM_PLUGIN_DEALCLOUD = 'CRM_PLUGIN_DEALCLOUD',
    CRM_PLUGIN_DYNAMO = 'CRM_PLUGIN_DYNAMO',
    CRM_PLUGIN_HUBSPOT = 'CRM_PLUGIN_HUBSPOT',
    CRM_PLUGIN_MS_DYNAMICS = 'CRM_PLUGIN_MS_DYNAMICS',
    CRM_PLUGIN_PROSEEDER = 'CRM_PLUGIN_PROSEEDER',
    CRM_PLUGIN_SALESFORCE = 'CRM_PLUGIN_SALESFORCE',
    EXCEL_PLUGIN = 'EXCEL_PLUGIN',
    EXCEL_PLUGIN_JS = 'EXCEL_PLUGIN_JS',
    EXTERNAL_LINK = 'EXTERNAL_LINK',
    LCD_COMPS = 'LCD_COMPS',
    MOBILE = 'MOBILE',
    NEWSLETTER = 'NEWSLETTER',
    PB_ADMIN = 'PB_ADMIN',
    POWER_POINT_PLUGIN = 'POWER_POINT_PLUGIN',
    PLATFORM = 'PLATFORM',
    PUBLIC_API = 'PUBLIC_API',
    RESEARCH_ALERT = 'RESEARCH_ALERT',
    SURVEY = 'SURVEY',
    THIRD_PARTY_AI_INTEGRATIONS = 'THIRD_PARTY_AI_INTEGRATIONS',
    UDMP = 'UDMP',
    FRONTIER = 'FRONTIER',
    CLIENT_PORTAL = 'CLIENT_PORTAL'
}